import { useEffect, useState } from "react";
import { useUserAuth } from "../context/UserAuthContext";
import axios from "axios";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { FiEdit2 } from "react-icons/fi";
import { Link } from "react-router-dom";

const WorkingAddressList = () => {
    const { user, token } = useUserAuth();
    const merchant_id = user?.uid;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        if (!merchant_id) return;

        const getWorkingAddressList = async () => {
            try {
                const res = await axios.get(
                    `${base_url}/api/v1/users/working-address-list/${merchant_id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                setData(res.data.data || []);
            } catch (error) {
                console.log(error);
                toast.error("Failed to load working address list");
            }
        };

        getWorkingAddressList();
    }, [merchant_id, token]);

    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <div className="card">
                    <div
                        className="card-header d-flex justify-content-between align-items-center"
                        style={{ backgroundColor: "#085f9a" }}
                    >
                        <input
                            type="text"
                            placeholder="Search by address / pincode..."
                            className="form-control w-25"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />

                        <Link to="/dashboard/working-address">
                            <button className="btn btn-light">
                                <FiEdit2 className="btn-icon" />
                                Add Working Address
                            </button>
                        </Link>
                    </div>
                    <div className="card-body">
                        <h3>Working Address List</h3>
                        <div className="table-responsive">
                            <table className="table table-bordered shadow-sm mt-3">
                                <thead>
                                    <tr>
                                        <th>S. No.</th>
                                        <th>Country</th>
                                        <th>State</th>
                                        <th>City</th>
                                        <th>Locality</th>
                                        <th>Landmark</th>
                                        <th>Pincode</th>
                                        <th>Full Address</th>
                                        <th>Status</th>
                                        <th>Created At</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {data
                                        ?.filter((item) =>
                                            (item.full_address || "")
                                                .toLowerCase()
                                                .includes(searchQuery.toLowerCase()) ||
                                            (item.pincode || "")
                                                .toLowerCase()
                                                .includes(searchQuery.toLowerCase())
                                        )
                                        .map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.country_name}</td>
                                                <td>{item.state_name}</td>
                                                <td>{item.city_name}</td>
                                                <td>{item.locality_name || "-"}</td>
                                                <td>{item.landmark || "-"}</td>
                                                <td>{item.pincode}</td>
                                                <td>{item.full_address || "-"}</td>
                                                <td>
                                                    <span
                                                        className={`badge ${item.status === "approved"
                                                            ? "bg-success"
                                                            : item.status === "rejected"
                                                                ? "bg-danger"
                                                                : "bg-warning text-dark"
                                                            }`}
                                                    >
                                                        {item.status}
                                                    </span>
                                                </td>
                                                <td>
                                                    {dayjs(item.created_at).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                            </tr>
                                        ))}

                                    {data.length === 0 && (
                                        <tr>
                                            <td colSpan={10} className="text-center">
                                                No record found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkingAddressList;